import request from '@/utils/request'
import { CONFIG } from "../base";

export function getDictItems(dictClass, dictItem)
{
  // 请求数据
  return request(
    {
      url: CONFIG + "/SearchDictItem/queryItem",
      method: 'get',
      async: false,
      params:
      {
        dictClassCode: dictClass,
        dictItemCode: dictItem,
      },
      headers:
      {
        _extend_config:
        {
          loading:
          {
            showLoading: false
          }
        }
      }
    });
}


// WEBPACK FOOTER //
// ./src/api/config/DictData.js